import { FC, ReactNode } from "react";
import { WidgetTitle } from "../WidgetTitle";

interface MiniTableProps {
    children: ReactNode;
    title?: string;
    link?: {
        title: string;
        url: string;
    }
}
export const MiniTable: FC<MiniTableProps> = ({
    children,
    title,
    link,
}) => {
    return (
        <div className="rounded-xl w-full">
            <WidgetTitle linkUrl={link.url} linkTitle={link.title} title={title} />
            {children}
        </div>
    );
}